import { AtlasSalesSummaryV2PageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasSalesSummaryV2PageLayout';
import { AtlasSalesUnitsSoldV2PageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasSalesUnitsSoldV2PageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasSalesV2PageLayout({ metricType }) {
  const salesPageLayouts = {
    retailSales: AtlasSalesSummaryV2PageLayout,
    unitsSold: AtlasSalesUnitsSoldV2PageLayout
  };
  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'AtlasSalesV2PageLayout',
        CustomComponent: salesPageLayouts[metricType],
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
